import React, { useState, useEffect } from "react";
import { motion, useViewportScroll, useTransform } from "framer-motion";

import scrolldown from "../images/scrolldown_w.png";

function BouncingMouse() {
  const { scrollY } = useViewportScroll();

  const [elementTop, setElementTop] = useState(0);
  const [elementBottom, setElementBottom] = useState(0);

  useEffect(() => {
    const el = document.querySelector(".js-hero");

    const setValues = () => {
      setElementTop(el.offsetTop);
      setElementBottom(el.offsetTop + el.offsetHeight);
    };
    setValues();
    document.addEventListener("load", setValues);
    window.addEventListener("resize", setValues);

    return () => {
      document.removeEventListener("load", setValues);
      window.removeEventListener("resize", setValues);
    };
  }, []);

  const opacity = useTransform(
    scrollY,
    [elementTop, (elementTop + elementBottom) / 2],
    [0.6, 0]
  );

  return (
    <div className="absolute mb-10 bottom-0 w-full mx-auto flex justify-center">
      <motion.img
        className="bounce scrolldown w-15 h-15 lg:w-18 lg:h-18"
        src={scrolldown}
        alt="scrolldown icon"
        style={{ opacity }}
      />
    </div>
  );
}

export default BouncingMouse;
